// extracted by mini-css-extract-plugin
export default {"CandidateCardHeader":"Ql1ro","CandidateCardHeader__avatar":"uSEEv","CandidateCardHeader__name":"CA_Gd","CandidateCardHeader__role":"Pzzrt","CandidateCardHeader__blured":"TIc7b"};